<script setup lang="ts">
import type { CmsElementHtml } from "~/composables/useCustom";
import {computed, onMounted} from "vue";

const props = defineProps<{
  content: CmsElementHtml;
}>();

const { data } = props.content
const htmlContent = computed(() => data.content );

onMounted(() => {
  let scriptEle = document.createElement("script");
  scriptEle.setAttribute("src", "https://tracking.paqato.com/scripts/pqt-tracking.min.js");
  document.head.appendChild(scriptEle);

  scriptEle.addEventListener("load", () => {
    window.pqtTracking(635994);
  });
});

</script>

<template>

  <section class="section section-main section-subscribe section--solid"  :style="props.style" :class="props.class">
    <div class="container">
      <div class="section__inner">
        <div id="pqt-tracking"></div>
      </div>
    </div>
  </section>
</template>

<style>
.pqt-wrapper .pqt-main-title {
  font-size: 28px;
  margin-bottom: 30px;
}
</style>